import $ from 'jquery';
import Cookies from 'js-cookie';
import AjaxRequest from "../modules/ajax-request";

class Login {
    constructor(element, modal) {
        this._div = element;
        this._modal = modal;
        this._loginHtml = "";
        this._rememberHtml = "";
        this._loginAction = "";
        this._rememberAction = "";
        this._unmaskInput = "";

        this.getData();
        this.clearData();
        this.bindEvents();
    }
    getData() {
        this._loginHtml = $(this._div).data('login-html');
        this._rememberHtml = $(this._div).data('remember-html');
        this._loginAction = $(this._div).data('login-action');
        this._rememberAction = $(this._div).data('remember-action');
        this._unmaskInput = $(this._div).find('[data-unmask-input]');
    }
    clearData() {
        $(this._div).removeAttr('data-login-html');
        $(this._div).removeAttr('data-remember-html');
        $(this._div).removeAttr('data-login-action');
        $(this._div).removeAttr('data-remember-action');
    }
    bindEvents() {
        var _thisLogin = this;
        $(this._div).on("click", "[data-password-remember]", function (event) {
            _thisLogin.showRememberForm(event);
        });
        $(this._div).on("click", "[data-back-to-login]", function (event) {
            _thisLogin.showLoginForm(event);
        });
        $(this._div).on("click", "[data-login-close]", function (event) {
            _thisLogin.closeModal(event);
        });
        $(this._div).on("submit", "[name='login_form']", function (event) {
            _thisLogin.submitLoginForm(event);
        });
        $(this._div).on("submit", "[name='remember_form']", function (event) {
            _thisLogin.submitRememberForm(event);
        });
        $(this._div).on("click", '[data-unmask-pwd]', function (event) {
            _thisLogin.togglePasswordMask(event, this);
        });
    }
    showLoginForm(event) {
        event.preventDefault();
        if (this._modal) {
            $(this._div).find("[data-remember-block]").remove();
            $(this._div).find("[data-modal-wrapper]").html(this._loginHtml);
            $(this._div).fadeIn();
        } else {
            $(this._div).html(this._loginHtml);
        }
        this._unmaskInput = $(this._div).find('[data-unmask-input]');
        if (parseInt(Cookies.get("cs_logged")) === 1) {
            $(this._div).find("[data-login-block]").addClass("is-logged");
        }
    }
    showRememberForm(event) {
        event.preventDefault();
        if (this._modal) {
            $(this._div).find("[data-login-block]").remove();
            $(this._div).find("[data-modal-wrapper]").html(this._rememberHtml);
        } else {
            $(this._div).html(this._rememberHtml);
            if (parseInt(Cookies.get("cs_logged")) === 1) {
                $(this._div).find("[data-login-block]").addClass("is-logged");
            }
        }
    }
    closeModal(event) {
        event.preventDefault();
        $(this._div).fadeOut();
        $(this._div).find("[data-login-block]").remove();
        $(this._div).find("[data-remember-block]").remove();
    }
    submitLoginForm(event) {
        event.preventDefault();
        var _loginForm = $(this._div).find("[name='login_form']");
        var _formMessage = $(_loginForm).find("[data-login-feedback]");
        var _thisLogin = this;
        $(_formMessage).html("");
        $(_formMessage).removeClass("is-failure is-success");
        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_loginForm).removeClass("loading");
                $(_formMessage).html(response.message);
                $(_formMessage).addClass("is-success");
                $(_thisLogin._div).find("[data-login-block]").addClass("is-logged");
                if (_thisLogin._modal) {
                    location.reload();
                }
            },
            errorCallback: function (response) {
                $(_loginForm).removeClass("loading");
                $(_formMessage).html(response.responseJSON.message);
                $(_formMessage).addClass("is-failure");
            }
        });
        $(_loginForm).addClass("loading");
        _ajaxRequest.makeCall(this._loginAction, $(_loginForm).serialize());
    }
    submitRememberForm(event) {
        event.preventDefault();
        var _rememberForm = $(this._div).find("[name='remember_form']");
        var _formMessage = $(_rememberForm).find("[data-login-feedback]");
        var _thisLogin = this;
        $(_formMessage).html("");
        $(_formMessage).removeClass("is-failure is-success");
        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_rememberForm).removeClass("loading");
                $(_formMessage).html(response.message);
                $(_formMessage).addClass("is-success");
                $(_thisLogin._div).find("[data-remember-block]").addClass("is-logged");
            },
            errorCallback: function (response) {
                $(_rememberForm).removeClass("loading");
                $(_formMessage).html(response.responseJSON.message);
                $(_formMessage).addClass("is-failure");
            }
        });
        $(_rememberForm).addClass("loading");
        _ajaxRequest.makeCall(this._rememberAction, $(_rememberForm).serialize());
    }
    togglePasswordMask(event, element) {
        event.preventDefault();
        $(element).toggleClass("is-active");
        if ($(this._unmaskInput).attr("type") === "password") {
            $(this._unmaskInput).attr("type", "text");
        } else {
            $(this._unmaskInput).attr("type", "password");
        }
    }
}

export default Login;